import Swal from 'sweetalert2';
import { getState } from '~src/state';
import { getMetadata } from '~loader/loader-utils';
import { getAxiosClient } from '~src/api';

/**
 * Handle spell check report submission
 * @param {fabric.Textbox} textbox - The textbox with spell check results
 * @param {Array} matches - The spell check matches
 */
export async function handleSpellCheckReport(textbox, matches) {
  // Prepare error details for display
  const errorDetails = matches
    .map((match) => {
      const errorText = textbox.text.substring(
        match.offset,
        match.offset + match.length
      );
      const suggestions = match.replacements
        .slice(0, 3)
        .map((r) => r.value)
        .join(', ');
      return `<li><strong style="color: #ff0000;">${errorText}</strong> → ${suggestions}</li>`;
    })
    .join('');

  const result = await Swal.fire({
    title: 'Segnala errore ortografico',
    html: `
      <div style="text-align: left; margin-bottom: 15px;">
        <p><strong>Testo completo:</strong></p>
        <p style="background: #f5f5f5; padding: 10px; border-radius: 4px; margin-bottom: 15px;">${textbox.text}</p>
        <p><strong>Correzioni suggerite:</strong></p>
        <ul style="margin-left: 20px;">${errorDetails}</ul>
      </div>
      <div style="margin-top: 20px;">
        <label for="report-note" style="display: block; margin-bottom: 5px; font-weight: bold;">Note aggiuntive (opzionale):</label>
        <textarea id="report-note" class="swal2-textarea" placeholder="Descrivi il problema o suggerisci una correzione..." style="width: 100%; min-height: 100px;"></textarea>
      </div>
    `,
    showCancelButton: true,
    confirmButtonText: 'Invia segnalazione',
    cancelButtonText: 'Annulla',
    confirmButtonColor: '#278e8e',
    cancelButtonColor: '#d33',
    width: '600px',
    preConfirm: () => {
      const note = document.getElementById('report-note').value;
      return { note };
    },
  });

  if (result.isConfirmed) {
    // Gather all the data
    const user = getState('user');
    const metadata = getMetadata();
    const servizioId =
      metadata?.servizioId || getState('selected.servizio.objectId');

    const reportData = {
      text: textbox.text,
      spellCheckResults: textbox.spellCheckResults,
      note: result.value.note,
      canvasId: window.editorLoader?.canvasId,
      projectId: metadata?.projectId,
      funeralServiceId: servizioId,
      user: user
        ? {
            id: user.objectId,
            email: user.email,
            username: user.username,
          }
        : null,
      org: user?.organization
        ? {
            id: user.organization.objectId,
            name: user.organization.name,
          }
        : null,
      metadata: {
        projectType: metadata?.projectTypeName,
        format: metadata?.formatName,
        timestamp: new Date().toISOString(),
        userAgent: navigator.userAgent,
      },
    };

    try {
      // Show loading state
      Swal.fire({
        title: 'Invio segnalazione...',
        text: 'Attendere prego',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      // Make API call
      const httpClient = await getAxiosClient();

      await httpClient({
        url: `${process.env.PARSE_API_URL}/user/report`,
        method: 'POST',
        data: {
          type: 'spellcheck_error',
          data: reportData,
        },
        responseType: 'json',
      });

      // Show success message
      await Swal.fire({
        icon: 'success',
        title: 'Segnalazione inviata',
        text:
          'Grazie per il tuo contributo! La segnalazione è stata inviata correttamente.',
        confirmButtonText: 'OK',
        confirmButtonColor: '#278e8e',
      });
    } catch (error) {
      console.error('Error submitting spell check report:', error);

      // Show error message
      await Swal.fire({
        icon: 'error',
        title: 'Errore',
        text:
          "Si è verificato un errore durante l'invio della segnalazione. Riprova più tardi.",
        confirmButtonText: 'OK',
        confirmButtonColor: '#278e8e',
      });
    }
  }
}

// Export to window for global access
window.handleSpellCheckReport = handleSpellCheckReport;

export default handleSpellCheckReport;
